import type { FC } from 'react'
import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import { followCursor } from 'tippy.js'
import type { FaqCategoryData } from '@/api/kubik/monolith'
import { BubblingTooltip, Image } from '@/components/ui'
import { useData } from '@/logic/data'
import { pushFormattedGtmEvent } from '@/logic/metrika/helpers'
import { getTransliteratedGtmEvents } from '@/pages/QuestionsAndAnswers/gtmHelpers'
import './styles.scss'

const FaqMainPage: FC = () => {
  const { data: root } = useData<FaqCategoryData>('faqCategories', {
    shouldLoadForcibly: true,
  })
  const { children: categories } = root || {}

  return (
    <div className="page-wrapper faq-main-page">
      {categories?.map(({ name, image, status, id }) => {
        const isDeveloping = status === 'IN_DEVELOPING'

        return (
          <CommonLink
            key={name}
            url={isDeveloping ? '' : `/faq/categories/${id}`}
            spanIfEmpty
            onClick={() => pushFormattedGtmEvent(getTransliteratedGtmEvents({ blockName: name, isCategory: true }))}
          >
            <BubblingTooltip
              messageId="faq.category.inDeveloping.tooltip"
              tooltipProps={{
                theme: 'light-border',
                trigger: 'click',
                onShow: instance => {
                  setTimeout(instance.hide, 2000)
                },
                placement: 'top-start',
                followCursor: 'initial',
                // @ts-ignore
                plugins: [followCursor],
                enabled: isDeveloping,
              }}
            >
              <div className={classNames('faq-main-page-category', { 'faq-main-page-category_in-developing': isDeveloping })}>
                <Image src={image} className="faq-main-page-category__image" />
                <h3>{name}</h3>
              </div>
            </BubblingTooltip>
          </CommonLink>
        )
      })}
    </div>
  )
}

export default FaqMainPage
